module.exports = __webpack_public_path__ + "static/media/play.d24972ad.png";